module.exports = __webpack_public_path__ + "69f722de9dc7c58c29b419bd2a05679f.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/stomach/stomach-19.png
// module id = 3075
// module chunks = 0